import { render, staticRenderFns } from "./VerificationModal.vue?vue&type=template&id=0a55cd86&scoped=true&"
import script from "./VerificationModal.vue?vue&type=script&lang=js&"
export * from "./VerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55cd86",
  null
  
)

export default component.exports